export const elibraryRegExp = /(http|https\:\/\/)?(?:www\.)?elibrary\.ru\/item\.asp\?id=(\d+)/gi


// WEBPACK FOOTER //
// ./src/shared/resoucesRegexps.js